<script>
import { Line, mixins } from "vue-chartjs";
import { getRandomColor } from "../../src/base";
import { fetchDataServive } from "../base";


export default {
  extends: Line,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await fetchDataServive()
      .then((response) => {
        
        // console.log(response);
        function getNumber(str) {
          return str.replace(/[^0-9.]/g, "");
        }

        //create function to convert "3 days, 14 hours, 52 minutes" to days
        function convertToDays(str) {
          let days = 0;
          let hours = 0;
          let minutes = 0;
          let seconds = 0;
          let uptime = str.split(", ");
          uptime.forEach((item) => {
            if (item.includes("days")) {
              days = parseInt(item.replace(" days", ""));
            } else if (item.includes("hours")) {
              hours = parseInt(item.replace(" hours", ""));
            } else if (item.includes("minutes")) {
              minutes = parseInt(item.replace(" minutes", ""));
            } else if (item.includes("seconds")) {
              seconds = parseInt(item.replace(" seconds", ""));
            }
          });
          let totalDays = days + hours / 24 + minutes / 1440 + seconds / 86400;
          return totalDays.toFixed(2);
        }

        const color1 = getRandomColor();
        const color3 = getRandomColor();
        //const color_x = getRandomColor();
        const color_y = getRandomColor();
        //const color_xx = getRandomColor();
        const color_yy = getRandomColor();
    
        this.chartData = {
          labels: ["heap (MB)", "heaptotal (MB)", "rss (MB)", "uptime (Days)"],
          datasets: [
          
          
            {
              label: "NODE St. Louis",
              backgroundColor: color3,
              //pointBackgroundColor: color_xx,
              borderWidth: 4,
              pointBorderColor: color_yy,
              data: [getNumber(response.status1.heap), getNumber(response.status1.heaptotal), getNumber(response.status1.rss), convertToDays(response.status1.uptime)],
            },
            {
              label: "NODE Los Angeles",
              backgroundColor: color1,
              //pointBackgroundColor: color_x,
              borderWidth: 4,
              pointBorderColor: color_y,
              data: [getNumber(response.status2.heap), getNumber(response.status2.heaptotal), getNumber(response.status2.rss), convertToDays(response.status2.uptime)],
            },
            
          ],
        };

        this.chartOptions = {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          legend: {
            display: true,
          },
          responsive: true,
          maintainAspectRatio: false,
        };
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>
